import { getSuggestionsApiCall } from "../api/suggestion-v2.apis";
import { onFailure, onSuccess, setLoading } from "../store/suggestion-v2.store";

  /*----- THUNKS ------*/
  export const getSuggestions = (id: string, searchTerms = '') => (dispatch: Function) => {
    dispatch(setLoading(id));
  
    getSuggestionsApiCall(searchTerms)
      .then(res => res.status <= 399 ? res.json() : false)
      .then(suggestions => suggestions ? dispatch(onSuccess({id, suggestions})) : dispatch(onFailure(id)))
      .catch(() => dispatch(onFailure(id)));
  };